import { useCanAccess, useResourceContext } from "ra-core";
import type { ReactNode } from "react";

/**
 * Renders children (a delete button) only for whoever has the personal right
 * «может удалять» (sales.can_delete; the owner always). The database refuses
 * the delete without it as well.
 */
export const CanDelete = ({
  children,
  resource,
}: {
  children: ReactNode;
  resource?: string;
}) => {
  const fromContext = useResourceContext();
  const { canAccess, isPending } = useCanAccess({
    resource: resource ?? fromContext ?? "",
    action: "delete",
  });
  if (isPending || !canAccess) return null;
  return children;
};
